import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@material-ui/core';

const POSICOES_DIGITO = [0, 1, 3, 4];

const minutosParaDigitos = (minutosTotais) => {
  const total = Math.max(0, parseInt(minutosTotais, 10) || 0);
  const horas = Math.min(99, Math.floor(total / 60));
  const minutos = total % 60;
  return `${String(horas).padStart(2, '0')}${String(minutos).padStart(2, '0')}`.split('');
};

const digitosParaTexto = (digitos) => `${digitos[0]}${digitos[1]}:${digitos[2]}${digitos[3]}`;

const digitosParaMinutos = (digitos) => {
  const horas = parseInt(digitos[0] + digitos[1], 10) || 0;
  const minutos = Math.min(59, parseInt(digitos[2] + digitos[3], 10) || 0);
  return horas * 60 + minutos;
};

export default function DuracaoInput({ label, valueMinutos, onChangeMinutos, disabled, helperText }) {
  const inputRef = useRef(null);
  const [digitos, setDigitos] = useState(() => minutosParaDigitos(valueMinutos));
  const [posicaoAtiva, setPosicaoAtiva] = useState(0);

  useEffect(() => {
    setDigitos(minutosParaDigitos(valueMinutos));
  }, [valueMinutos]);

  useEffect(() => {
    const posicaoNoTexto = POSICOES_DIGITO[posicaoAtiva];
    inputRef.current?.setSelectionRange(posicaoNoTexto, posicaoNoTexto + 1);
  }, [posicaoAtiva, digitos]);

  const irParaPosicaoMaisProxima = (posicaoNoTexto) => {
    let indice = POSICOES_DIGITO.findIndex((p) => p >= posicaoNoTexto);
    if (indice === -1) indice = POSICOES_DIGITO.length - 1;
    setPosicaoAtiva(indice);
  };

  const handleClick = (e) => {
    irParaPosicaoMaisProxima(e.target.selectionStart ?? 0);
  };

  const escreverDigito = (valor) => {
    const novosDigitos = [...digitos];
    novosDigitos[posicaoAtiva] = valor;
    setDigitos(novosDigitos);
    onChangeMinutos(digitosParaMinutos(novosDigitos));
    setPosicaoAtiva((atual) => Math.min(atual + 1, POSICOES_DIGITO.length - 1));
  };

  const apagar = () => {
    const novosDigitos = [...digitos];
    novosDigitos[posicaoAtiva] = '0';
    setDigitos(novosDigitos);
    onChangeMinutos(digitosParaMinutos(novosDigitos));
    setPosicaoAtiva((atual) => Math.max(atual - 1, 0));
  };

  const handleKeyDown = (e) => {
    if (/^[0-9]$/.test(e.key)) {
      e.preventDefault();
      escreverDigito(e.key);
      return;
    }

    if (e.key === 'Backspace') {
      e.preventDefault();
      apagar();
      return;
    }

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      setPosicaoAtiva((atual) => Math.max(atual - 1, 0));
      return;
    }

    if (e.key === 'ArrowRight') {
      e.preventDefault();
      setPosicaoAtiva((atual) => Math.min(atual + 1, POSICOES_DIGITO.length - 1));
      return;
    }

    if (e.key !== 'Tab') {
      e.preventDefault();
    }
  };

  return (
    <TextField
      type="text"
      label={label}
      margin="normal"
      variant="outlined"
      fullWidth
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      value={digitosParaTexto(digitos)}
      onChange={() => {}}
      helperText={helperText}
      inputProps={{ inputMode: 'numeric' }}
      InputProps={{
        inputRef,
        onClick: handleClick,
        onFocus: handleClick,
        onKeyDown: handleKeyDown,
      }}
    />
  );
}
